'use es6';

export default {
  ASC: 'ascending',
  DESC: 'descending',
  NONE: 'none'
};